<template>
  <footer class="app-footer">
    <span><a href="https://www.takubo.co.jp/">Takubo</a> &copy; 2006 - 2024</span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue